import { lazy } from "react";

const SystemPlansPage = lazy(() => import("@/widgets/system-admin/plans/PlansPage"));

const SystemPlanRoutes = {
  path: "plans",
  children: [{ index: true, element: <SystemPlansPage /> }],
};

export default SystemPlanRoutes;
